<template>
    <div class="table-row">
        <Row>
            <Col v-for="(item, index) in fields" :key="index" span="8" class="margin-b-10">
            <label class="expand-key">{{ item.name }}&nbsp;:</label>
            <div class="expand-value">
                <template v-if="item.code === 'sex'">
                    {{ row[item.code] === '1' ? '女' : '男' }}
                </template>
                <template v-else-if="item.code === 'createTime'">
                    {{ row.userInfo[0].createTime }}
                </template>
                <template v-else>
                    {{ row[item.code] || '--' }}
                </template>
            </div>
            </Col>
        </Row>
        <Row>
            <Col span="24">
            <div class="flex">
                <div class="expand-key" style="width: 50px">角色&nbsp;:</div>
                <div class="expand-value margin-left-20">
                    <Tag v-for="(item, index) in row.roleNameList" :key="`${index}-${item}`"
                         :color="item.includes('管理员') ? 'orange' : 'blue'">{{ item }}
                    </Tag>
                </div>
            </div>
            </Col>
        </Row>
    </div>
</template>

<script>

export default {
    name: 'TableExpand',
    props: {
        row: Object,
        fields: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            data: []
        }
    },
    methods: {
        checkNull(item) {
            console.log(item)
            return item || '--'
        }
    }
}
</script>
<style lang="less" scoped>
    .expand-key, .expand-value {
        display: inline-block;
    }
    .expand-value {
        margin-left: 10px;
    }
    .ivu-col {
        margin-bottom: 10px;
    }
</style>
